import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/api.service';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable()
export class BHQrCodeSiteScannerService {
    constructor(
        private _httpClient: HttpClient,
        private _apiService: ApiService,
    ) {
    }

    doGetSiteInfosAction(siteInfosParams: any) {
        return this._httpClient.post(this._apiService.workspaceEndpointUrl + "/api/BlackHawk/doGetSiteInfosAction_BlackHawk", siteInfosParams)
        .pipe(catchError(error => throwError(!!error.error ? error.error.Message : 'Une erreur est survenue lors de la requete au serveur')));
    }
}